/**
 * Component: edificio-details
 */
<template>
  <div class="container-fluid container-edificio-details">
    <div class="icon-spinner-grey" v-if="isLoading"></div>
    <div v-if="!isLoading">
      <div class="row">
        <div class="col form-group">
          <label for="edificioDetailsNombre">Nombre</label>
          <input type="text" class="form-control" id="edificioDetailsNombre" v-model="nombre" v-bind:class="{ 'is-invalid': fieldErrors.nombre }">
          <p v-if="fieldErrors.nombre">{{ fieldErrors.nombre[0] }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col form-group">
          <button class="btn btn-primary" v-on:click="submitForm">Enviar</button>
        </div>
      </div>
      <div class="row" v-if="messageContent">
        <div class="col">
          <div v-bind:class="{'alert': true, 'alert-success': messageType == 'success', 'alert-warning': messageType == 'alert', 'alert-danger': messageType == 'error' }">{{ messageContent }}</div>
        </div>
      </div>
      <div v-if="deleteEdificioUrl">
        <hr>
        <div class="row">
          <div class="col form-group">
            <button class="btn btn-secondary btn-sm" v-on:click="deleteThisEdificio">Borrar este edificio</button>
          </div>
        </div>
      </div>
    </div>
  </div><!--.container-fluid.container-ticket-details-->
</template>

<script>

import apiService from '../services/api-service.js';

export default {
  props: [
    "edificioId",
    "edificiosUrl",
    "deleteEdificioUrl",
  ],
  data() {
    return {
      nombre: "",
      isLoading: false,
      messageContent: "",
      messageType: "",
      fieldErrors: {}
    };
  },
  created(event) {
    this.getEdificio();
  },
  methods: {
    beginLoadingState(resetMessages) {
      if(resetMessages == null) {
        resetMessages = true;
      }
      this.isLoading = true;
      if(resetMessages) {
        this.messageType = ""; // success | alert | error
        this.messageContent = "";
        this.fieldErrors = {};
      }
    },
    endLoadingState(messageType, messageContent) {
      this.isLoading = false;
      if(messageType) {
        this.messageType = messageType;
      }
      if(messageContent) {
        this.messageContent = messageContent;
      }
    },
    getEdificio() {
      this.beginLoadingState();
      axios({
        method: "get",
        url: apiService.ajaxUrl + '-edificio/' + this.edificioId,
      }).then(response => {
        if(response.data.status == apiService.STATUS_OK) {
          this.endLoadingState();
          this.nombre = response.data.nombre;
          /**
           * If we have just creeted a edificio, the hash 'new' will be present
           */
          if(window.location.hash) {
            if(window.location.hash == '#new') {
              this.messageType = 'success';
              this.messageContent = "Se ha creado un nuevo edificio";
              window.location.hash = '';
            }
          }
        } else if(response.data.status == apiService.STATUS_VALIDATION_FAILED) {
          this.endLoadingState("alert", response.data.message);
        } else {
          this.endLoadingState("error", response.data.message);
        }
      }).catch(error => {
        this.endLoadingState("error", "Error de conexión");
      });
    },
    submitEdificio() {
      this.beginLoadingState();
      axios({
        method: "post",
        url: apiService.ajaxUrl + '-edificio/' + this.edificioId,
        params: {
          nombre: this.nombre
        }
      }).then(response => {
        if(response.data.status == apiService.STATUS_OK) {
          this.password = this.password_confirmation = "";
          if(this.edificioId == 0) {
            document.location.href = this.edificiosUrl+'/'+response.data.edificioId+'#new';
          } else {
            this.endLoadingState("success", response.data.message);
          }
        } else if(response.data.status == apiService.STATUS_VALIDATION_FAILED) {
          this.fieldErrors = response.data.errors;
          this.endLoadingState("alert", response.data.message);
        } else {
          this.endLoadingState("error", "Error: " + response.data.message);
        }
      }).catch(error => {
        this.endLoadingState("error", "Error de conexión");
      });
    },
    submitForm() {
      this.submitEdificio();
      return false;
    },
    deleteThisEdificio() {
      if(window.confirm("Está seguro de querer eliminar este edificio. Esta acción no se puede desacer.")) {
        document.location.href = this.deleteEdificioUrl;
      }
    }
  }
}
</script>
